<template>
  <div
    :class="['textarea-container', { 'bg-confirm': isPostTextarea }]"
  >
    <editor-content
      :editor="editor"
      class="textarea-main"
      :class="{ 'height-92': isPostTextarea }"
    />
    <div v-if="editor && !isPostTextarea && isTools" class="textarea-tools">
      <button
        type="button"
        @click="editor.chain().focus().toggleBold().run()"
        :class="{ 'is-active': editor.isActive('bold') }"
      >
        <img src="@/assets/images/bold.svg" alt="bold" />
      </button>
      <button
        type="button"
        @click="editor.chain().focus().toggleItalic().run()"
        :class="{ 'is-active': editor.isActive('italic') }"
      >
        <img src="@/assets/images/italic.svg" alt="italic" />
      </button>
      <button
        type="button"
        @click="editor.chain().focus().toggleBulletList().run()"
        :class="{ 'is-active': editor.isActive('bulletList') }"
      >
        <img src="@/assets/images/list.svg" alt="list" />
      </button>
      <button type="button" @click="editor.chain().focus().undo().run()">
        <img src="@/assets/images/undo.svg" alt="undo" />
      </button>
      <button type="button" @click="editor.chain().focus().redo().run()">
        <img src="@/assets/images/redo.svg" alt="redo" />
      </button>
    </div>
  </div>
</template>

<script setup>
import Placeholder from '@tiptap/extension-placeholder';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useEditor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';

const props = defineProps({
  content: {
    type: String,
    default: null,
  },
  isPostTextarea: {
    type: Boolean,
    default: false,
  },
  isTools: {
    type: Boolean,
    default: true,
  },
  placeholderValue: {
    type: String,
    default: '入力してください',
  },
  hasEditable: {
    type: Boolean,
    default: true,
  },
  document_link: {
    type: Array,
    default: () => [''],
  },
});
const editor = useEditor({
  content: props.content,
  extensions: [
    StarterKit,
    Placeholder.configure({
      placeholder: props.placeholderValue,
    }),
  ],
  editable: props.hasEditable,
});
</script>

<style lang="scss">
@import '@/assets/scss/textarea/index.scss';
</style>
